// extracted by mini-css-extract-plugin
export default {"container":"DishtypePreferences-module__container__On3Pn"};